import SendEmailReport from './SendEmailReport';

export default SendEmailReport;
